import React, { Fragment } from 'react';
import { Separator, VStack } from '@chakra-ui/react';
import type { FiboSearchHeadline } from '@/constants/fibo/fibosearch';
import { FiboSearchHeadlineText } from '@/constants/fibo/fibosearch';
import type { GroupedFiboHeadlineWithItems } from '@/models/fibo/fibosearch';
import { FibosearchCombobox } from './FibosearchCombobox';
import { RenderItem } from './RenderItem';

export type GroupContentProps = {
  groupedCollection: Array<[FiboSearchHeadline, GroupedFiboHeadlineWithItems]>;
  inputValue: string;
};

export const CollectionGroup = ({ groupedCollection, inputValue }: GroupContentProps) => (
  <>
    {groupedCollection.map(([key, groupData]) => (
      <FibosearchCombobox.ItemGroup key={key}>
        <VStack width="100%" paddingY="4px" gap={1} alignItems="flex-start">
          <FibosearchCombobox.ItemGroupLabel textStyle="caption1" textTransform="uppercase">
            {FiboSearchHeadlineText[key]}
          </FibosearchCombobox.ItemGroupLabel>
          <Separator width="100%" />
        </VStack>
        {groupData.items.map((item) => (
          <Fragment key={item.label}>
            <RenderItem item={item} inputValue={inputValue} />
          </Fragment>
        ))}
      </FibosearchCombobox.ItemGroup>
    ))}
  </>
);
